(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const slides = [...root.querySelectorAll('[data-slide]')];
    if (!slides.length) return;
    const tabs = [...root.querySelectorAll('[data-slide-to]')];
    const pause = root.querySelector('[data-slide-pause]');
    const status = root.querySelector('[data-slide-status]');
    let current = 0, timer, stopped = reduced.matches || root.dataset.autoplay !== 'true', hovering = false, focused = false, visible = true, start = null;
    const delay = 6500;
    function schedule() {
      clearTimeout(timer);
      root.classList.toggle('is-paused', stopped || hovering || focused || !visible || document.hidden);
      if (!stopped && !hovering && !focused && visible && !document.hidden && slides.length > 1) timer = setTimeout(() => show(current + 1), delay);
    }
    function show(index, announce = false) {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === current;
        slide.classList.toggle('active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
      tabs.forEach((tab, i) => {
        tab.classList.toggle('selected', i === current);
        if (i === current) tab.setAttribute('aria-current', 'true'); else tab.removeAttribute('aria-current');
      });
      root.dataset.active = String(current);
      root.dataset.tone = slides[current].classList.contains('slide-lime') ? 'light' : 'dark';
      if (announce && status) status.textContent = slides[current].getAttribute('aria-label');
      schedule();
    }
    function updatePause() {
      if (!pause) return;
      pause.textContent = stopped ? '▷' : 'Ⅱ';
      pause.setAttribute('aria-label', stopped ? 'Play slideshow' : 'Pause slideshow');
      pause.setAttribute('aria-pressed', String(stopped));
    }
    root.querySelector('[data-slide-prev]')?.addEventListener('click', () => show(current - 1, true));
    root.querySelector('[data-slide-next]')?.addEventListener('click', () => show(current + 1, true));
    tabs.forEach(tab => tab.addEventListener('click', () => show(Number(tab.dataset.slideTo), true)));
    pause?.addEventListener('click', () => { stopped = !stopped; updatePause(); schedule(); });
    root.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') { hovering = true; schedule(); } });
    root.addEventListener('pointerleave', () => { hovering = false; schedule(); });
    root.addEventListener('focusin', () => { focused = true; schedule(); });
    root.addEventListener('focusout', () => { setTimeout(() => { focused = root.contains(document.activeElement); schedule(); }, 0); });
    root.addEventListener('keydown', e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); show(current + (e.key === 'ArrowRight' ? 1 : -1), true); } });
    root.addEventListener('touchstart', e => { start = { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY }; }, { passive: true });
    root.addEventListener('touchend', e => { if (!start) return; const dx = e.changedTouches[0].clientX - start.x, dy = e.changedTouches[0].clientY - start.y; if (Math.abs(dx) > 65 && Math.abs(dx) > Math.abs(dy) * 1.5) show(current + (dx < 0 ? 1 : -1), true); start = null; }, { passive: true });
    document.addEventListener('visibilitychange', schedule);
    reduced.addEventListener('change', e => { if (e.matches) { stopped = true; updatePause(); schedule(); } });
    if ('IntersectionObserver' in window) new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); }, { threshold: 0.2 }).observe(root);
    root.addEventListener('shopify:block:select', e => { const index = slides.findIndex(s => s.contains(e.target) || s === e.target); if (index >= 0) { stopped = true; show(index); updatePause(); } });
    updatePause(); show(0);
  }
  document.querySelectorAll('[data-slider]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-slider]').forEach(init));
})();

